<template>
  
  <div class="card card-custom gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">{{ $t('TRANSLATOR.MAINTENANCE') }}</span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm"></span>
      </h3>
      <div class="card-toolbar">
        <b-dropdown
          size="sm"
          variant="link"
          toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
          no-caret
          right
          no-flip
        >
          <template v-slot:button-content>
            <slot><i class="ki ki-calendar-2"></i></slot>
          </template>
          <!--begin::Navigation-->
          <div class="navi navi-hover min-w-md-250px">
            <b-dropdown-text tag="div" class="navi-header font-weight-bold text-center">
              <a href="#" @click="lastMonth" class="btn btn-primary font-weight-bolder font-size-sm m-2">
                <span class="svg-icon svg-icon-md svg-icon-white">
                  <inline-svg src="media/svg/icons/Code/Right-circle.svg" />
                </span>Last month</a>
              <a href="#" @click="thisMonth" class="btn btn-primary font-weight-bolder font-size-sm m-2">
                <span class="svg-icon svg-icon-md svg-icon-white">
                  <inline-svg src="media/svg/icons/Code/Right-circle.svg" />
                </span>This month</a>
            </b-dropdown-text>
            <b-dropdown-text tag="div" class="navi-header font-weight-bold">
              <v-date-picker
                v-model="dates"
                width="290"
                range
                scrollable
                no-title
              ></v-date-picker>
          
            </b-dropdown-text>
          </div>
        </b-dropdown>

        <a href="#" @click="ApplyDates" class="btn btn-primary font-weight-bolder font-size-sm ml-3">
          <span class="svg-icon svg-icon-md svg-icon-white">
            <inline-svg src="media/svg/icons/Code/Right-circle.svg" />
          </span>Apply</a>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body py-0 pb-5">
      <b-row>
        <b-col md="6">          
          <b-form-group id="input-group-2" label="" label-for="input-2" class="mb-3">
            <b-form-input
              id="input-2"
              v-model="form.name"
              v-on:keyup="(e) => FilterData(e.target.value)"
              :placeholder="$t('TRANSLATOR.SEARCH')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6" class="text-right">
        <b-button class="mb-3"
          @click="submit('green')"
          :class="active == 'green' ? ' active' : ''"
          variant="success"
          >{{ $t('TRANSLATOR.GREEN') }}</b-button>
        <b-button class="mb-3"
          @click="submit('orange')"
          :class="active == 'orange' ? ' active' : ''"
          variant="warning"
          >{{ $t('TRANSLATOR.ORANGE') }}</b-button>
        <b-button class="mb-3"
          @click="submit('red')"
          :class="active == 'red' ? ' active' : ''"
          variant="danger"
          >{{ $t('TRANSLATOR.RED') }}</b-button>
        <b-button class="mb-3" @click="submit('all')">{{ $t("TRANSLATOR.CLEAR", { msg: "CLEAR" }) }}</b-button>
        </b-col>
      </b-row>
    </div>
    <div class="card-body py-0">
      <!--begin::Table-->
      <div class="table-responsive">
        <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
          <thead>
            <tr class="text-left">
              <th class="pl-0" style="width: 55px">{{ $t('TRANSLATOR.STATUS', { msg: 'STATUS' }) }}</th>
              <th style="min-width: 100px">{{ $t('TRANSLATOR.LINE') }}</th>
              <th class="" style="min-width: 100px; max-width: 150px">{{ $t('AUTH.INPUT.USERNAME') }}</th>
              <th class="" style="min-width: 60px; max-width: 100px">{{ $t('PARTS.PARTS') }}</th>
              <th class="text-right" style="min-width: 145px; max-width: 160px">{{ $t('ECOMMERCE.DATE', { msg: 'DATE' }) }}</th>
              <th class="text-right" style="min-width: 75px; max-width: 90px"></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in lines">
              <tr v-bind:key="i">
                <td class="pl-0">
                  <span v-if="item.newStatus === 'green' || item.newStatus === ''"  class="label label-lg label-inline label-light-success">
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Navigation/Check.svg" />
                    </span>
                  </span>
                  <span v-if="item.newStatus === 'orange'"  class="label label-lg label-inline label-light-warning">
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Code/warning-1-circle.svg" />
                    </span>
                  </span>
                  <span v-if="item.newStatus === 'red'"  class="label label-lg label-inline label-light-danger">
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Code/Warning-2.svg" />
                    </span>
                  </span>
                </td>
                <td>
                  <a v-bind:href="`#/line/${item.lineNumber}/conveyor/${item.conveyorNumber}`" class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg" >
                    <!-- {{ item.lineName }} -->
                    {{ $t('TRANSLATOR.LINE', { msg: 'LINE' }) }} {{ item.lineNumber }} > {{ item.conveyorNumber }}
                  </a>
                </td>
                <td> {{ item.userName }}
                </td>
                <td> 
                  <span class="badge badge-light" v-show="item.note != 'inspected to Survey'">{{ item.sparePart }}</span>
                  <span class="badge badge-light" v-show="item.note == 'inspected to Survey'">[inspected to Survey]</span>
                </td>
                <td class="text-right">
                  <span class="text-muted font-weight-bold">{{  item.date }}</span>
                </td>
                <td rowspan="2" class="text-right">
                  <div v-if="item.imagePath != ''" class="symbol symbol-75 symbol-light mr-2">
                    <span class="symbol-label">
                      <b-img class="h-75 align-self-center" fluid @click="open(item.imagePath)" v-b-modal.modal-1
                        v-bind:src="'media/' + item.imagePath" alt="Image 1"></b-img>
                    </span>
                  </div>
                </td>
              </tr>
              <tr v-bind:key="i">
                <td colspan="5" style="border-top: none;"><span class="text-muted font-size-md" v-show="item.note != 'inspected to Survey'">{{ $t('TRANSLATOR.NOTES') }} : {{item.note}}</span></td>
              </tr>
            </template>
          </tbody>
        </table>
    <div>
      <b-modal id="modal-1">
        <b-img fluid v-bind:src="'media/' + imagePath" alt="Image Big"></b-img>
      </b-modal>
    </div>
      </div>
      <!--end::Table-->
      <div class="row" v-if="loading">
        <div class="col-md-12">
          <div class="text-center">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from 'axios';
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "home",
  components: {
  },  
   data() {
     return {
       loading: false,
       lines: [],
      filterData: [],
      dates: [this.startdate, this.enddate],
      form: {
        name: "",
      },
      imagePath: '',
       // Note 'isActive' is left out and will not appear in the rendered table
       fields: [
         {
           key: 'last_name',
           sortable: true
         },
         {
           key: 'first_name',
           sortable: true
         },
         {
           key: 'age',
           label: 'Person age',
           sortable: true,
           // Variant applies to the whole column, including the header and footer
          //  variant: 'warning'
         }
       ]
      }
    },
  mounted() {
    this.startdate = (new Date(new Date().getFullYear()-5, new Date().getMonth()-1, 2)).toISOString().substr(0, 10); // get the last 5 years
    this.enddate = (new Date(Date.now())).toISOString().substr(0, 10);
    this.dates = [this.startdate, this.enddate];
    this.ApplyDates();
    this.$root.$on("BrowserCallBack", () => {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `Maintenance`,
          route: `/`,
        },
      ]);  
    }),
    this.loading = true;
    axios.get('/line/maintenance', {
          params: {
              'startdate' : this.dates[0],
              'enddate' : this.dates[1]
          }
      })
      .then(response => {
        // console.log(response.data);
        this.lines = response.data;
        this.filterData = response.data;
        this.loading = false;
      })
      .catch(err => {
          this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
        throw err
        })
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Maintenance" }]);
  },
  methods: {
    FilterData: function (e) {
      if (e.length >= 3) {
        let newData = this.filterData.filter(
          (item) =>
            item.userName.toLowerCase().includes(e.toLowerCase()) || item.date.toLowerCase().includes(e.toLowerCase()) || item.note.toLowerCase().includes(e.toLowerCase())
        );
        this.lines = newData;
      }
      if (e.length == 0) {
        this.lines = this.filterData;
      }
    },
    submit: function (e) {
      this.active = e;
      if (e == "red") {
        let newData = this.filterData.filter((item) => item.newStatus === 'red');
        this.lines = newData;
      }
      if (e == "orange") {
        let newData = this.filterData.filter(
          (item) => item.newStatus === 'orange'
        );
        this.lines = newData;
      }
      if (e == "green") {
        let newData = this.filterData.filter(
          (item) => item.newStatus === 'green' || item.newStatus === '' 
        );
        this.lines = newData;
      }
      if (e == "all") {
        this.lines = this.filterData;
      }
    },
    open(imagePath) {
      this.imagePath = imagePath
    },
    thisMonth: function() {
      this.startdate = (new Date(new Date().getFullYear(), new Date().getMonth(), 2)).toISOString().substr(0, 10);
      this.enddate = (new Date(Date.now())).toISOString().substr(0, 10);
      this.dates = [this.startdate, this.enddate];
      this.ApplyDates()
    },
    lastMonth: function() {
      this.startdate = (new Date(new Date().getFullYear(), new Date().getMonth()-1, 2)).toISOString().substr(0, 10);
      this.enddate = (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10);
      this.dates = [this.startdate, this.enddate];
      this.ApplyDates()
    },
    ApplyDates() {    
    this.loading = true;
    axios.get('/line/maintenance', {
          params: {
              'startdate' : this.dates[0],
              'enddate' : this.dates[1]
          }
      })
      .then(response => {
        // console.log(response.data);
        this.lines = response.data;
        this.filterData = response.data;
        this.loading = false;
      })
      .catch(err => {
          this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
        throw err
        })
    },
  },
  computed: {
    dateRangeText () {
      return this.dates.join(' ~ ')
    },
  },
};
</script>

<style lang="scss">
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}

.navi .navi-header {
    padding: 0;
}

.b-dropdown-text {
    padding: 0;
}

.v-picker__title {
  background-color: #2196f3 !important;
  color: white;
}
.v-date-picker-table .v-btn.v-btn--active {
  background-color: #c7c7c7 !important;
}
</style>